import { Grommet } from "grommet";
import React from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import { EASTER_EGG } from "../config";
import { STORAGE_AUTH_TOKEN } from "../constants/storage";
import * as r from "../routes";
import { fetchSelfAsync, setAuthToken } from "../store/modules/user/actions";
import theme from "../theme";
import App from "./App";
import AuthenticatedRoute from "./AuthenticatedRoute";
import Calculator from "./Calculator";
import Login from "./Login";
import SignUp from "./SignUp";

Modal.setAppElement("#root");

type ContainerProps = {
  setAuthToken: (authToken: string) => void;
  fetchSelf: () => void;
};

type ContainerState = {};

class Container extends React.Component<ContainerProps, ContainerState> {
  constructor(props: ContainerProps) {
    super(props);
    const { setAuthToken } = props;
    const authToken = localStorage.getItem(STORAGE_AUTH_TOKEN);
    if (authToken) {
      setAuthToken(authToken);
    }
    console.log(EASTER_EGG);
  }

  render() {
    return (
      <Grommet full theme={theme}>
        <Router>
          <Switch>
            <Route path={r.ROUTE_CALCULATOR}>
              <Calculator />
            </Route>
            <Route exact path={r.ROUTE_LOGIN}>
              <Login />
            </Route>
            <Route exact path={[r.ROUTE_SIGN_UP, r.ROUTE_REGISTER]}>
              <SignUp />
            </Route>
            <AuthenticatedRoute path={r.ROUTE_APP}>
              <App />
            </AuthenticatedRoute>
            {/* <Route path={r.ROUTE_START}>
              <Start />
            </Route> */}
            {/* <Route path={r.ROUTE_ONBOARDING}>
              <Onboarding />
            </Route> */}
            {/* <AuthenticatedRoute path={r.ROUTE_ACCOUNT}>
              <Account />
            </AuthenticatedRoute> */}
            {/* <AuthenticatedRoute path={r.ROUTE_TFA_SETUP}>
              <TFASetup />
            </AuthenticatedRoute> */}
            {/* <AuthenticatedRoute path={r.ROUTE_DEPOSIT}>
              <Deposit />
            </AuthenticatedRoute>
            <AuthenticatedRoute path={r.ROUTE_RECURRING_DEPOSIT}>
              <RecurringDeposit />
            </AuthenticatedRoute> */}

            <Redirect to={r.ROUTE_APP} />
          </Switch>
        </Router>
      </Grommet>
    );
  }
}

export default connect(
  () => {
    return {};
  },
  (dispatch) => {
    return {
      setAuthToken: (authToken: string) => dispatch(setAuthToken(authToken)),
      fetchSelf: () => dispatch(fetchSelfAsync.request()),
    };
  }
)(Container);
